export default __webpack_public_path__ + "static/media/regreen_visual_02.6a1df4f1.jpg";